import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

const AuthContext = createContext();

export function useAuth() {
    return useContext(AuthContext);
}

export function AuthProvider({ children }) {
    const [currentUser, setCurrentUser] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        checkSession();
    }, []);

    const checkSession = async () => {
        try {
            const response = await axios.post('/api/auth/check-session');
            if (response.data.authenticated) {
                setCurrentUser(response.data.user);
            }
        } catch (error) {
            console.error('Session check failed:', error);
        } finally {
            setLoading(false);
        }
    };

    const login = async (identifier, password) => {
        try {
            const response = await axios.post('/api/auth/login', { identifier, password });
            setCurrentUser(response.data.user);
            return response.data;
        } catch (error) {
            throw new Error(error.response?.data?.error || 'Login failed');
        }
    };

    const logout = async () => {
        try {
            await axios.post('/api/auth/logout');
            setCurrentUser(null);
        } catch (error) {
            console.error('Logout error:', error);
            // Clear user anyway
            setCurrentUser(null);
        }
    };

    const value = {
        currentUser,
        login,
        logout,
        loading
    };

    return (
        <AuthContext.Provider value={value}>
            {!loading && children}
        </AuthContext.Provider>
    );
}